export interface TaxCalculationResult {
  unitCost: number;
  unitCostWithIva: number;
  ivaUnit: number;
  ivaTotal: number;
  totalCost: number;
}

/**
 * Calcula el detalle fiscal a partir del total neto sin IVA y la cantidad.
 * Usado principalmente en compras con crédito fiscal.
 */
export const calculateTaxFromTotalAndQty = (
  total: number,
  quantity: number,
  taxRate = 0.13
): TaxCalculationResult => {
  const unitCostWithIva = total / quantity;
  const unitCost = unitCostWithIva;
  const ivaTotal = total * taxRate;
  const ivaUnit = ivaTotal / quantity;
  const totalCompra = total + ivaTotal;

  const roundedTotal = Math.round(totalCompra * 100) / 100;
  const shouldRound = Math.abs(totalCompra - roundedTotal) < 0.00001;

  return {
    unitCost: parseFloat(unitCost.toFixed(10)),
    unitCostWithIva: parseFloat(unitCostWithIva.toFixed(10)),
    ivaUnit: parseFloat(ivaUnit.toFixed(10)),
    ivaTotal: parseFloat(ivaTotal.toFixed(10)),
    totalCost: parseFloat(
      (shouldRound ? roundedTotal : totalCompra).toFixed(10)
    ),
  };
};

/**
 * Calcula el detalle fiscal a partir del costo unitario neto sin IVA.
 * Usado cuando se edita manualmente el costo unitario.
 */
export const calculateTaxFromUnitCostAndQty = (
  unitCost: number,
  quantity: number,
  taxRate = 0.13
): TaxCalculationResult => {
  const total = unitCost * quantity;
  const ivaTotal = total * taxRate;
  const ivaUnit = ivaTotal / quantity;
  const totalCost = total + ivaTotal;
  const unitCostWithIva = unitCost + ivaUnit;

  const roundedTotalCost = Math.round(totalCost * 100) / 100;
  const shouldRound = Math.abs(totalCost - roundedTotalCost) < 0.00001;

  return {
    unitCost: parseFloat(unitCost.toFixed(10)),
    unitCostWithIva: parseFloat(unitCostWithIva.toFixed(10)),
    ivaUnit: parseFloat(ivaUnit.toFixed(10)),
    ivaTotal: parseFloat(ivaTotal.toFixed(10)),
    totalCost: parseFloat(
      (shouldRound ? roundedTotalCost : totalCost).toFixed(10)
    ),
  };
};
